export default "__VITE_ASSET__BGvgI6gh__"